import { TextField, OutlinedInput, InputAdornment, IconButton, InputLabel, FormControl } from '@mui/material'
import React from 'react'
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useLocation } from 'react-router-dom';
import axiosInstance from '@common/utils/axiosInstance';
import apiUrl from '@common/utils/apiURL';
import { getAuthHeaders } from '@common/utils/cart';
import { toast } from 'react-toastify';

function ResetPassword() {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');


    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                token: token,
                password: e.target.newPassword.value
            };
            const headers = getAuthHeaders();
            const response = await axiosInstance.post(apiUrl.auth.resetPassword, payload, { headers })
            if (response.status === 200) {
                toast.success('Password reset successfully!');
                window.location.href = window.location.origin + '/login';
            }
        } catch (error) {
            if (error?.response?.status === 405) {
                toast.error(error?.response?.data?.message)
            } else if (error?.response?.status !== 401) {
                toast.error('Error resetting password, please try again');
            }
            console.error("Error resetting password:", error);
        }
    }


    return (
        <div className='lyt-reset-pass'>
            <div className='lyt-reset-pass__cont-wrap'>
                <div className='lyt-reset-pass__title-wrap'>
                    <h3 className='lyt-reset-pass__title'>reset password</h3>
                    <p className='lyt-reset-pass__desc'>Enter your email and we’ll send you a link to reset your password.</p>
                </div>
                <form className='bs-form bs-form--typ-column' onSubmit={handleSubmit}>
                    <div className={`bs-form__form-group`}>
                        <TextField
                            id="newPassword"
                            name="newPassword"
                            type="text"
                            label="enter new password"
                            className='bs-form__form-control'
                        />
                    </div>
                    <div className={`bs-form__form-group`}>
                        <FormControl variant="outlined">
                            <InputLabel htmlFor="outlined-adornment-password">Re-enter password</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-password"
                                type={showPassword ? 'text' : 'password'}
                                className='bs-form__form-control'
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label={
                                                showPassword ? 'hide the password' : 'display the password'
                                            }
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            onMouseUp={handleMouseUpPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                label="Re-enter password"
                            />
                        </FormControl>
                    </div>
                    <div className={`bs-form__form-bottom-wrap`}>
                        <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl'>Confirm</button>
                        <button className='bs-btn bs-btn__btn-link mod-text-btn__link'>cancel</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ResetPassword